import React, { useEffect, useState } from "react";
import "./../profile.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Loader from "react-loader-spinner";
import { profileAction } from "../../../redux/action";
import Pagination from "rc-pagination";
import useDebounce from "../../../assets/hooks/useDebounce";
const color: any = {
  "1": "#EE811F",
  "2": "#399CA0",
  "3": "#DB0000",
  "4": "red",
};
const PaymentHistory = () => {
  const [open, setOpen] = useState<any>("");
  const [payHistory, setPayHistory] = useState<any[]>([]);
  const [searchTermShow, setSearchTermShow] = useState<any>("");
  const [searchTerm, setSearchTerm] = useState<any>("");
  const [amount, setAmount] = useState<any>("");
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const paymentHistory = useSelector((state: any) => state?.profile?.paymentHistory || []);
  const itemsPerPage = 20;
  const totalpayment = useSelector((state: any) => state?.profile?.totalpaymentHistory || []);
  const commonLoading: any = useSelector((state: any) => (state.common.loader ? state.common.loader : false));

  useEffect(() => {
    setPayHistory(paymentHistory || []);
  }, [paymentHistory, currentPage]);

  const debouncedSearchTerm = useDebounce(searchTerm, 800); // 500ms debounce delay

  useEffect(() => {
    const isNumeric = /^\d+$/.test(debouncedSearchTerm);
      const payload = isNumeric
        ? { SearchTerm: null, Amount: debouncedSearchTerm?.trim(), Page: currentPage }
        : { SearchTerm: debouncedSearchTerm?.trim(), Amount: null, Page: currentPage };

      dispatch(profileAction.paymentHistoryAction(payload));
    // bookingHistory();
  }, [debouncedSearchTerm, dispatch, currentPage]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value?.trimStart();
    setSearchTermShow(val);
    setSearchTerm(val);
    setCurrentPage(1);
    const isNumeric = /^\d+$/.test(val);
    if (isNumeric) {
      setAmount(val);
    } else {
      setAmount("");
    }
  };
  // const bookingHistory = () => {
  //   dispatch(profileAction.paymentHistoryAction({ Page: currentPage }));
  // };
  const handlePaginationP = (page: number) => {
    // setOffsetP((page - 1) * limit);
    setCurrentPage(page);
  };

  return (
    <div className="tc_box">
      <div className="heading_box">
        <div className="row justify-content-between">
          <span className="col">Payment History</span>
          <span className="col text-right d-flex align-items-center justify-content-end">
            <div className="acc_search_inp">
              <input placeholder="Search or filter payment" value={searchTermShow} onChange={handleSearch} />
              <img src="/assets/img/my-profile/search.png" alt="" />
            </div>
            {/* <img
              src="/assets/img/my-profile/filter.png"
              alt=""
              className="ml-2"
              height={18}
              width={18}
            /> */}
          </span>
        </div>
      </div>
      {commonLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader type="ThreeDots" color="#fff" height={100} width={100} />
        </div>
      ) : (
        <div className="payment_history_Table">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Description</th>
                <th className="text-center">Status</th>
                <th className="text-center">Transaction Id</th>
                <th className="text-center">Payment Method</th>
                <th className="text-center">Paid</th>
              </tr>
            </thead>
            <tbody>
              {payHistory && payHistory?.length > 0 ? (
                payHistory?.map((payment: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <tr>
                      <td
                        width={60}
                        className="text-center cursor-pointer"
                        onClick={() => setOpen(open != payment?.id ? payment?.id : "")}
                      >
                        <i
                          className={
                            open == payment?.id
                              ? "fa fa-angle-up font-weight-bold"
                              : "fa fa-angle-down font-weight-bold"
                          }
                        ></i>
                      </td>
                      <td>
                        <div className="order_id">Booking ID {payment?.CRMBookingId}</div>
                        <div>
                          (
                          {payment?.transaction_log?.slice(-1)?.[0]?.created_at
                            ? moment(payment?.transaction_log?.slice(-1)?.[0]?.created_at)?.format("DD MMM, YYYY hh:mm A")
                            : ""}
                          )
                        </div>
                      </td>
                      <td
                        align="center"
                        style={{
                          color: color[payment?.transaction_log?.slice(-1)[0]?.status],
                        }}
                      >
                        {payment?.transaction_log?.slice(-1)[0]?.Status || payment?.transaction_log?.slice(-1)[0]?.comment}
                      </td>
                      <td align="center">{payment?.PaymentTxnId}</td>
                      <td align="center">{payment?.payment_method}</td>
                      <td
                        align="center"
                        style={{
                          color: color[payment?.transaction_log?.slice(-1)[0]?.status],
                        }}
                      >
                        {payment?.transaction_log?.slice(-1)[0]?.status == 4 && "-"}₹
                        {payment?.transaction_log?.slice(-1)[0]?.amount || payment?.amount}
                      </td>
                    </tr>
                    {open == payment?.id && (
                      <tr className="bg-transparent">
                        <td colSpan={6} className="py-1 px-5">
                          <table className="table-bordered">
                            <thead>
                              <tr className="border-top-0">
                                <th>S No.</th>
                                <th>Status</th>
                                <th>Date Time</th>
                                <th>Amount</th>
                              </tr>
                            </thead>
                            {payment?.transaction_log?.length > 0 && (
                              <tbody className="m-0">
                                {payment?.transaction_log?.map((ele: any, number: any) => (
                                  <tr className="border-top-0">
                                    <td>{number + 1}</td>
                                    <td>{ele?.Status || ele?.comment}</td>
                                    <td>
                                      {" "}
                                      {ele?.created_at ? moment(ele?.created_at)?.format("DD MMM, YYYY hh:mm A") : ""}
                                    </td>
                                    <td style={{ color: ele?.status == 4 ? "red" : "" }}>
                                      {ele?.status == 4 ? "-" : ""}₹{ele?.amount}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            )}
                          </table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan={6}>
                    <div className="text-center"> No history found</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {totalpayment?.Count > 0 && (
        <div className="row justify-content-between pb-3 mt-4">
          <div className="col-md-3"></div>
          <div className="col-md-9 d-flex justify-content-end align-items-center">
            <div className="mr-3 f-14">{`Showing  ${(currentPage - 1)*itemsPerPage + 1} - ${(currentPage - 1)*itemsPerPage + totalpayment?.Result?.length} of ${totalpayment?.Count} Result`}</div>
            <div className="ml-3">
              <Pagination
                onChange={handlePaginationP}
                current={currentPage}
                total={totalpayment?.Count || 0}
                pageSize={itemsPerPage}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentHistory;
